import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/renewEmployment",
      name: "renewEmployment",
      meta: { requiresAuth: true, title: "routes.renewEmployment" },
      component: () => import("./main.vue")
    }
  ]
};
